import { render, staticRenderFns } from "./No22.vue?vue&type=template&id=0b8352ee&scoped=true"
import script from "./No22.vue?vue&type=script&lang=js"
export * from "./No22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8352ee",
  null
  
)

export default component.exports